export default class LegendContral {
  static legendVm = null

  static highLight(legend, children) {
    LegendContral.legendVm && LegendContral.legendVm.highLight(legend, children)
  }
}
